import {useEffect} from 'react';

import {
  useYandexAdsContextSelector,
  YandexAdsContextCommonSelectors,
  YandexAdsContextType,
} from '../context/YandexAdsContext';

const getAddActiveAdsType = (state: YandexAdsContextType) =>
  state.addActiveAdsType;

export const useRequestContextScriptLoad = (
  type: 'adfox' | 'yandex',
  enabled = true,
) => {
  const addActiveAdsType = useYandexAdsContextSelector(getAddActiveAdsType);

  const scriptState = useYandexAdsContextSelector(
    YandexAdsContextCommonSelectors.getScriptState,
  );

  useEffect(() => {
    if (enabled) {
      addActiveAdsType(type);
    }
  }, [type, enabled, addActiveAdsType]);

  return scriptState;
};
